"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _svgElements = require("../../components/svg-elements");

var _countdown = require("./countdown.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Countdown = function Countdown(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      playing = _ref.playing,
      previewHoverState = _ref.previewHoverState,
      progressPercentage = _ref.progressPercentage,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var countdownConfig = config || _hotspot.countdown;
  var CIRCUMFERENCE = 46 * 2 * Math.PI;
  var OFFSET = CIRCUMFERENCE - progressPercentage / 100 * CIRCUMFERENCE;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_countdown.ClickableAreaStyled, {
    onClick: onClick,
    playing: playing,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, _react.default.createElement(_countdown.ExpandingBoundingBoxStyled, {
    borderColor: countdownConfig.borderColor
  }), iconPosition && _react.default.createElement(_countdown.CountdownContainer, {
    iconPosition: iconPosition
  }, _react.default.createElement(_svgElements.Svg, {
    className: "center-circle",
    height: "0.8em",
    width: "0.8em",
    viewBox: "0 0 100 100"
  }, _react.default.createElement(_svgElements.Circle, {
    cx: "50%",
    cy: "50%",
    r: "45",
    stroke: "none",
    fill: countdownConfig.circleColor
  })), _react.default.createElement(_countdown.CountdownCircleWrapper, {
    viewBox: "0 0 100 100"
  }, _react.default.createElement(_countdown.CountdownCircle, {
    cx: "50",
    cy: "50",
    strokeColor: countdownConfig.circleColor,
    strokeWidth: 2,
    strokeDasharray: "".concat(CIRCUMFERENCE, " ").concat(OFFSET),
    strokeDashoffset: CIRCUMFERENCE,
    r: "46"
  }))));
};

var _default = Countdown;
exports.default = _default;